import { blueGrey } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

const externalClaimsTheme = (outerTheme) =>
    createTheme({
        ...outerTheme,
        palette: {
            ...outerTheme.palette,
            primary: {
                main: '#1c9cd4',
            },
            secondary: {
                main: '#1c9cd4',
            },
            tertiary: {
                main: '#30c4f8',
            },
            text: {
                primary: blueGrey[900],
                secondary: blueGrey[600],
            },
        },
        typography: outerTheme.typography,
        components: {
            ...(outerTheme.components || {}),
            MuiButton: {
                styleOverrides: {
                    root: {
                        // Common button styles if needed
                    },
                    containedPrimary: {
                        backgroundColor: '#0451ab',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#033c7a',
                        },
                    },
                    containedSecondary: {
                        backgroundColor: '#1c9cd4',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#137ca1',
                        },
                    },
                },
            },
            MuiOutlinedInput: {
                ...(outerTheme.components?.MuiOutlinedInput || {}),
                styleOverrides: {
                    ...(outerTheme.components?.MuiOutlinedInput?.styleOverrides || {}),
                    root: {
                        ...((outerTheme.components?.MuiOutlinedInput?.styleOverrides || {}).root),

                        '&$focused $notchedOutline': {
                            borderColor: "#1c9cd4"
                        }
                    },
                    notchedOutline: {
                        // fallback for direct notchedOutline targeting
                        borderColor: '#bdbdbd',
                    }
                },
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        fontSize: '2rem', // Increase tooltip font size
                    },
                },
            },
            MuiInputLabel: {
                ...(outerTheme.components?.MuiInputLabel || {}),
                styleOverrides: {
                    ...(outerTheme.components?.MuiInputLabel?.styleOverrides || {}),
                    root: {
                        ...((outerTheme.components?.MuiInputLabel?.styleOverrides || {}).root),
                        '&.Mui-focused': {
                            color: '#1c9cd4',
                        },
                    },
                },
            },
        },
    });

export default externalClaimsTheme;